var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单管理")]),
              _c("el-breadcrumb-item", [_vm._v("Dcops工单")]),
              _c("el-breadcrumb-item", [_vm._v("服务器退役")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.create_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "create_time", $$v)
                                },
                                expression: "searchForm.create_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "超时时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleOlaTimeChange },
                              model: {
                                value: _vm.searchForm.olaTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "olaTime", $$v)
                                },
                                expression: "searchForm.olaTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单ID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单ID" },
                              model: {
                                value: _vm.searchForm.TicketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "TicketId", $$v)
                                },
                                expression: "searchForm.TicketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "时效" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择时效"
                                },
                                model: {
                                  value: _vm.searchForm.rd_olaTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "rd_olaTime", $$v)
                                  },
                                  expression: "searchForm.rd_olaTime"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "预超时", value: "1" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "超时-进行中", value: "2" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "超时-完成", value: "3" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域-园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.Campus,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "Campus", $$v)
                                  },
                                  expression: "searchForm.Campus"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态分组" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "退役阶段"
                                },
                                model: {
                                  value: _vm.statusGroup,
                                  callback: function($$v) {
                                    _vm.statusGroup = $$v
                                  },
                                  expression: "statusGroup"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "进行中",
                                    value: "in_progress"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "已完成/已终止",
                                    value: "done"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "处理人" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "支持模糊搜索",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.ProcessUsers,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ProcessUsers", $$v)
                                },
                                expression: "searchForm.ProcessUsers"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("服务器退役列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      plain: "",
                      loading: _vm.syncLoading,
                      disabled: _vm.syncLoading
                    },
                    on: { click: _vm.openSyncDialog }
                  },
                  [_vm._v("更新退役列表")]
                ),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.showData, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      align: column.align
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "TicketId"
                                ? [
                                    scope.row.TicketId
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.TicketId))
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                : column.prop === "InstanceStatus"
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.statusTagType(
                                            scope.row.InstanceStatus
                                          ),
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.InstanceStatus || "-"
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                : column.prop === "SlaOffset"
                                ? [
                                    _c(
                                      "span",
                                      { class: _vm.slaOffsetClass(scope.row) },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatSlaOffset(scope.row))
                                        )
                                      ]
                                    )
                                  ]
                                : column.prop === "RetireTimeline"
                                ? [
                                    _c("div", { staticClass: "life-cycle" }, [
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot on"
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("起单")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.SocDispatchTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", {
                                        staticClass: "life-line",
                                        class: {
                                          on:
                                            !!scope.row.SocDispatchTime &&
                                            !!scope.row.CheckPointTime
                                        }
                                      }),
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: {
                                            on: !!scope.row.CheckPointTime
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("状态更新")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.CheckPointTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", {
                                        staticClass: "life-line",
                                        class: {
                                          on:
                                            !!scope.row.CheckPointTime &&
                                            !!scope.row.PullOutTime
                                        }
                                      }),
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: { on: !!scope.row.PullOutTime }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("拔盘完成")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.PullOutTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "life-duration" },
                                        [
                                          _vm._v(
                                            "耗时：" +
                                              _vm._s(
                                                _vm.formatRetireDuration(
                                                  scope.row
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCell(scope.row, column.prop)
                                      )
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "选择月份范围",
                  visible: _vm.monthSelectDialogVisible,
                  width: "700px",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.monthSelectDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.monthSelectForm,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "开始月份" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "month",
                            placeholder: "选择开始月份",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.startMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "startMonth", $$v)
                            },
                            expression: "monthSelectForm.startMonth"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束月份" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "month",
                            placeholder: "选择结束月份",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.endMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "endMonth", $$v)
                            },
                            expression: "monthSelectForm.endMonth"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.monthSelectDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmSyncMonthSelect }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  width: "420px",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }